import {connect} from "react-redux";
import NewsFeed from "./NewsFeed.jsx";
import {fetchFeedAction} from "./newsFeedActions";

const mapStateToProps = (state) => {
    return {
        ...state.newsFeed
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onLoad: () => dispatch(fetchFeedAction(ownProps.sport)),
    }
};

const NewsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewsFeed);

export default NewsContainer